(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    class ProductFreeShipping extends HTMLElement {
    connectedCallback() {
      document.addEventListener('cart:update', this.handleCartUpdate);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:update', this.handleCartUpdate);
    }

    handleCartUpdate = async (event) => {
      let total = event.detail?.resource?.total_price;

      if (typeof total !== 'number') {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
        if (!response.ok) return;
        total = (await response.json()).total_price;
      }

      this.updateProgress(total);
    };

    updateProgress(total) {
      const threshold = Number(this.dataset.threshold);
      const wasUnlocked = this.classList.contains('product-free-shipping--unlocked');
      const remaining = Math.max(threshold - total, 0);
      const unlocked = remaining === 0;
      const progress = Math.min((total / threshold) * 100, 100);
      const message = this.querySelector('.product-free-shipping__message');
      const progressbar = this.querySelector('[role="progressbar"]');
      const bar = this.querySelector('.product-free-shipping__bar');

      if (message) {
        const amount = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'EUR',
          minimumFractionDigits: remaining % 100 === 0 ? 0 : 2,
        }).format(remaining / 100);
        message.textContent = unlocked
          ? this.dataset.messageUnlocked
          : this.dataset.messageRemaining?.replace('[amount]', amount);
      }

      progressbar?.setAttribute('aria-valuenow', Math.round(progress).toString());
      bar?.style.setProperty('--product-free-shipping-progress', `${progress}%`);
      this.classList.toggle('product-free-shipping--unlocked', unlocked);

      if (unlocked && !wasUnlocked) {
        this.setAttribute('data-celebrate', '');
        setTimeout(() => this.removeAttribute('data-celebrate'), 1800);
      } else if (!unlocked) {
        this.removeAttribute('data-celebrate');
      }
    }
  }

  if (!customElements.get('product-free-shipping')) {
    customElements.define('product-free-shipping', ProductFreeShipping);
  }
  } catch(e) { console.error(e); }
})();

})();
